import styled from 'styled-components';

const TextDecorationSpan = styled.span`
   display: inline-block;
   border-bottom: 2px solid ${({ theme, color = theme.primaryBlueLight }: { color?: string; theme: any }) => color};
   padding-bottom: 1px;
`;

export default TextDecorationSpan;
